export default __webpack_public_path__ + "static/media/img-1.7732ed1d.jpg";